<template>
    <v-card flat tile class="transparent d-flex flex-nowrap align-center" min-height="26">
        <div class="timeItem-action d-flex align-center">
            <img class="timeItem-actionIcon mr-2" :src="'/icons/'+item.action.replace('dmr-', '')+'.svg'"/>
            <v-card flat tile class="timeItem-actionText transparent theme-title">{{item.label}}</v-card>
        </div>
        <v-card v-if="item.action !== 'timeOut' && item.action !== 'dmr-timeOut'" flat tile class="timeItem-number transparent theme-title">{{item.player.jersey}}</v-card>
        <v-card flat tile class="timeItem-name transparent theme-title mr-auto">{{item.player.name}}</v-card>
        <v-card v-if="item.draft" flat tile class="timeItem-reason transparent theme-title">Vázlat</v-card>
        <v-card v-if="!item.approved && item.rejectReason" flat tile class="timeItem-reason transparent theme-red mr-1">{{getReasonText(item.rejectReason)}}</v-card>
        <v-icon v-if="item.approved || item.rejectReason" :class="item.approved ? 'theme-green' : 'theme-red'">{{item.approved ? 'mdi-check' : 'mdi-close'}}</v-icon>
    </v-card>
</template>

<script>
    export default {
        name: 'TimelineTag',
        props: {
            item: Object,
            rejectReasons: Object
        },
        methods: {
            getReasonText: function (reason) {
                return this. rejectReasons[reason];
            }
        }
    }
</script>

<style scoped>
    .timeItem-action {
        min-width: 100px;
    }

    .timeItem-actionIcon {
        height: 26px;
        display: block;
    }

    .timeItem-actionText {
        font-size: 14px;
        font-stretch: condensed;
        font-family: 'Roboto Condensed';
        white-space: nowrap;
        margin-right: 10px;
        text-align: left;
    }

    .timeItem-number {
        font-size: 14px;
        font-weight: bold;
        font-stretch: condensed;
        font-family: 'Roboto Condensed';
        margin-right: 5px;
    }

    .timeItem-name {
        font-size: 14px;
        font-stretch: condensed;
        font-family: 'Roboto Condensed';
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .timeItem-reason {
        font-size: 14px;
        font-stretch: condensed;
        font-family: 'Roboto Condensed';
        white-space: nowrap;
    }
</style>
